import Vue from 'vue'
import 'vuetify/dist/vuetify.min.css'
import colors from "vuetify/lib/util/colors";
import Vuetify from "vuetify";
Vue.use(Vuetify);

let theme = localStorage.getItem('theme');
theme = theme ? JSON.parse(theme) : null

export default new Vuetify({
    theme: {
        dark: theme? theme.dark: false,
        themes: {
            light: {
                primary: '#A988EC',
                accent: colors.grey.darken3,
                secondary: '#000000',
                secondary2: '#858585',
                secondary3: '#F2F2F2',
                info: '#448AFF',
                warning: colors.amber.base,
                error: '#E53935',
                success: colors.green.accent3
            },
            dark: {
                primary: '#A988EC',
                accent: colors.grey.darken3,
                secondary: colors.amber.darken3,
                secondary2: '#858585',
                secondary3: '#F2F2F2',
                info: '#448AFF',
                warning: colors.amber.base,
                error: '#E53935',
                success: colors.green.accent3
            }
        },
    },
})
